import React, { useCallback, useEffect, useRef, useState } from 'react';

export default function useCountdown(initialNum: number) {
    const [{ countdown, isCounting }, setCountStatus] = useState({
        countdown: initialNum,
        isCounting: false
    });
    const timerRef = React.useRef<number>();
    const startTimeRef = useRef<number>();

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
            }
        };
    }, [initialNum]);

    const loop = useCallback(() => {
        if (startTimeRef.current) {
            const duration = initialNum - Math.floor((Date.now() - startTimeRef.current) / 1000);

            if (duration > 0) {
                timerRef.current = window.setTimeout(loop, 1000);
                setCountStatus({ countdown: duration, isCounting: true });
            } else {
                timerRef.current = startTimeRef.current = undefined;
                setCountStatus({ countdown: 0, isCounting: false });
            }
        } else {
            timerRef.current = undefined;
        }
    }, [initialNum, setCountStatus]);

    const start = useCallback(() => {
        startTimeRef.current = Date.now();
        setCountStatus({ countdown: initialNum, isCounting: true });
        timerRef.current = window.setTimeout(loop, 1000);
    }, [initialNum, loop]);

    return {
        countdown,
        start,
        isCounting,
        isEnd: countdown === 0
    };
}
